// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3rj5o","title":"ClientReferral_title__3TYB9","itemText":"ClientReferral_itemText__3u0Jr"};